import { Component } from '@angular/core';
@Component({
  selector: 'app-vessel-info',
  standalone: false,
  templateUrl: './vessel-info.component.html',
  styles: `
    :host {
      @apply z-10 h-full relative overflow-auto flex flex-1 flex-col gap-4 rounded-2xl;
    }
  `,
})
export class VesselInfoComponent {}
